<template>
  <section class="all_emp card_style">
    <div class="d-flex align-items-center gap-3 mb-2">
      <AddFavDailog v-tooltip.left="$t('add_to_favourite')" />
      <h4 class="mb-0">
        {{ $t("The most visited places") }}
      </h4>
    </div>
    <div
      class="main_header_style mb-2 d-flex align-items-center justify-content-between"
    >
      <input
        type="text"
        v-model="placesText"
        @keyup="fetchPlaces((page = 1))"
        class="form-control w-50"
        :placeholder="$t('search...')"
      />
      <router-link to="/visit_website/add" class="PrimaryButton btn"
        ><i class="fa-solid fa-plus"></i> {{ $t("add place") }}</router-link
      >
    </div>
    <div class="row">
      <div class="table-responsive">
        <table class="table places">
          <thead>
            <tr>
              <th>{{ $t("ID") }}</th>
              <th>{{ $t("Image") }}</th>
              <th>{{ $t("Title") }}</th>
              <th>{{ $t("city") }}</th>
              <th>{{ $t("rate") }}</th>
              <th>{{ $t("number_trip") }}</th>
              <th>{{ $t("price") }}</th>
              <th>{{ $t("Control") }}</th>
            </tr>
          </thead>

          <tbody v-if="loading" class="text-center">
            <tr v-for="place in 10" :key="place">
              <td>
                <Skeleton height="2rem" width="90%" class="mb-2"></Skeleton>
              </td>
              <td width="10%">
                <Skeleton shape="circle" size="5rem"></Skeleton>
              </td>
              <td v-for="place in 6" :key="place">
                <Skeleton height="2rem" width="90%" class="mb-2"></Skeleton>
              </td>
            </tr>
          </tbody>

          <tbody v-else>
            <tr v-for="(place, index) in places.data" :key="index">
              <td>{{ place.id }}</td>
              <td><img :src="place.image" :alt="place.title" /></td>
              <td>{{ place.title }}</td>
              <td>{{ place.city.title }}</td>
              <td>{{ place.rate }}</td>
              <td>{{ place.number_trip }}</td>
              <td>{{ place.price }}</td>
              <td>
                <router-link
                  :to="`/visit_website/edit/${place.id}`"
                  class="btn btn-success mx-1 w-auto"
                >
                  <i class="fa-regular fa-pen-to-square"></i>
                </router-link>

                <div
                  class="btn btn-danger mx-1 w-auto"
                  @click="deletePlace(place.id, index)"
                >
                  <i class="fa-solid fa-trash"></i>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="row">
      <pagination
        :data="places"
        class="mx-auto d-flex align-items-center justify-content-center pagination"
        @pagination-change-page="fetchPlaces"
      >
        <template v-slot:prev-nav>&lt;</template>
        <template v-slot:next-nav>&gt;</template>
      </pagination>
    </div>
  </section>
</template>

<script>
import AddFavDailog from "@/components/layout/addFavDailog.vue";
import axios from "axios";
import pagination from "laravel-vue-pagination";
import Swal from "sweetalert2";
import Skeleton from "primevue/skeleton";
export default {
  name: "all-services",
  data() {
    return {
      places: [],
      placesText: "",
      loading: true,
    };
  },
  components: {
    pagination,
    AddFavDailog,
    Skeleton,
  },
  methods: {
    fetchPlaces(page = 1) {
      axios
        .get(`/destinations?page=${page}`, { word: this.placesText })
        .then(({ data }) => {
          this.places = data.data;
          // console.log(this.titleCity)
          this.loading = false;
        });
    },
    deletePlace(placeID, index) {
      Swal.fire({
        title: this.$t("check_delete"),
        text: this.$t("are_you_sure_delete"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: this.$t("back"),
        confirmButtonText: this.$t("confirm_delete"),
      }).then((result) => {
        if (result.isConfirmed) {
          const fromClick = true;
          axios.delete(`/website/destinations/${placeID}`, { fromClick }).then(({ data }) => {
            if (data.status == true) {
              Swal.fire("", data.message, "success");
              this.places.data.splice(index, 1); // Remove the deleted item from the array
            } else {
              Swal.fire("", data.message, "error");
            }
          });
        }
      });
    },
  },
  mounted() {
    this.fetchPlaces();
  },
  created() {
    localStorage.removeItem("flightData");
    localStorage.removeItem("flightTrips");
    localStorage.removeItem("bookDataFlight");
    localStorage.removeItem("bookDetails");
    localStorage.removeItem("hotelData");
    localStorage.removeItem("bookData");
  },
};
</script>

<style scoped>
table tbody tr td img {
  width: 100px;
  height: 100px;
}
</style>
